import TenderOpeningTable from './TenderOpeningTable';

const ProductHydro = props => (
  <TenderOpeningTable {...props} procurementTypeHeader='1' />
);

export default ProductHydro;
